import '@/globals.css';
import '@/index.css';
import '@/lib/rum';
import {AppProps} from 'next/app';
import {StrictMode, createContext, useEffect} from 'react';
import {QueryClient, QueryClientProvider} from 'react-query';
import store from '../Core/mobx/RootStore';
import {GlobalError} from '@/components/global-error';
import {AppAbFlag} from '@amplify/athena-models';

const queryClient = new QueryClient();

export const RootStoreContext = createContext(store);

interface MyAppProps extends AppProps {
    pageProps: {
        abFlagScheme?: AppAbFlag[];
    };
}

export default function App({Component, pageProps}: MyAppProps) {
    useEffect(() => {
        // Initialize AB flags when app loads
        if (!store.abFlagsStore.isInitialized) {
            // Will use provided schema or fall back to backup
            store.abFlagsStore.initializeFlags(pageProps.abFlagScheme);
        }
    }, [pageProps.abFlagScheme]);
    return (
        <StrictMode>
            <GlobalError>
                <QueryClientProvider client={queryClient}>
                    <RootStoreContext.Provider value={store}>
                        <Component {...pageProps} />
                    </RootStoreContext.Provider>
                </QueryClientProvider>
            </GlobalError>
        </StrictMode>
    );
}
